import {
  Button as NatDsButton,
  IButtonProps as NatDsIButtonProps,
} from '@naturacosmeticos/natds-web'

export const Button = NatDsButton
export type IButtonProps = NatDsIButtonProps
